module.exports = __webpack_public_path__ + "img/pro_fourteen_8.efbd66e5.jpg";